export const VIEWER = 'roles/viewer';
export const EDITOR = 'roles/editor';
export const ADMIN = 'roles/admin';
export const OWNER = 'roles/owner';
export const ROLES = [
  { label: 'Viewer', value: VIEWER },
  { label: 'Editor', value: EDITOR },
  { label: 'Admin', value: ADMIN },
  { label: 'Owner', value: OWNER },
];
export function getRoleLabel(value: string): string {
  const item = ROLES.find(r => r.value === value);
  return item ? item.label : value || 'Unknown';
}

export const IS_ENABLED = [
  { label: 'Attivo', value: true },
  { label: 'Disattivo', value: false },
];
export function getIsEnabledLabel(value: boolean): string {
  const item = IS_ENABLED.find(r => r.value === value);
  return item ? item.label : 'Unknown';
}
